module.exports = __webpack_public_path__ + "static/img/tb4.8ebd7005.jpg";